<template>
  <drag-dialog
    :visible.sync="visible"
    custom-class="append-dialog"
    title="标签模版预览"
    width="fit-content"
    append-to-body
    :before-close="() => $emit('update:visible', false)"
  >
    <div slot="footer" class="dialog-header">
      <el-button type="primary" icon="el-icon-printer" size="small" @click="print">打 印</el-button>
      <el-button type="warning" icon="el-icon-tickets" size="small" @click="toPdf">pdf下载</el-button>
    </div>

    <div :id="previewHtmlId" class="preview-html"></div>
  </drag-dialog>
</template>

<script>
import { hiprint, disAutoConnect } from 'vue-plugin-hiprint';
disAutoConnect(); // 取消打印自动连接客户端打印机

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 每个插入该组件时的 previewHtmlId不一样，用于打印组件打印预览时，不冲突
    previewHtmlId: {
      type: String,
      default: 'preview_html'
    },
    activeInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      waitShowPrinter: false,
      // 模板
      hiprintTemplate: null
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.initTemplate();
      }
    }
  },
  computed: {},
  methods: {
    initTemplate() {
      const { templateCode } = this.activeInfo;

      const templateJson = JSON.parse(templateCode || '{}');

      this.$nextTick(() => {
        document.getElementById(this.previewHtmlId).innerHTML = '';

        hiprint.init();
        this.hiprintTemplate = new hiprint.PrintTemplate({
          template: templateJson
        });

        const printHtml = this.hiprintTemplate.getHtml(this.activeInfo.previewData);
        const insertDiv = document.getElementById(this.previewHtmlId);
        insertDiv.innerHTML = printHtml[0].innerHTML;
      });
    },
    print() {
      this.waitShowPrinter = true;
      this.hiprintTemplate.print(
        this.activeInfo.previewData,
        {},
        {
          callback: () => {
            this.waitShowPrinter = false;
          }
        }
      );
    },
    toPdf() {
      this.hiprintTemplate.toPdf(this.activeInfo.previewData, '模版预览pdf');
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.preview-html {
  padding: 0 40px;
  margin: 0 auto;
}
</style>
